import api from "../axios/axios-config";

export const getStaff = async () => {
  try {
    let response = await api.get("users/staffList");
    return response?.data?.data.reverse();
  } catch (error) {
    console.log("ERROR", error);
    return error?.response?.data;
  }
};

export const addUser = async (apiData) => {
  try {
    let response = await api.post("users/createStaff", apiData);
    return response?.data?.data;
  } catch (error) {
    console.log("ERROR", error);
    return error?.response?.data;
  }
};

export const updateUser = async (apiData) => {
  try {
    let response = await api.post("users/updateStaff", apiData);
    return response?.data?.data;
  } catch (error) {
    console.log("ERROR", error);
    return error?.response?.data;
  }
};

export const deleteStaff = async (userId, isDeleted) => {
  try {
    let response = await api.post(
      "users/updateStaff",
      {
        _id: userId,
        isDeleted,
      },
      
    );
    return response?.data?.data;
  } catch (error) {
    console.log("ERROR", error);
    return error?.response?.data;
  }
};

export const getStaffByDepartment = async (departmentId) => {
  try {
    let response = await api.post(
      "users/staffListByDepartment",
      {
        departmentId,
      },
      
    );
    return response?.data?.data;
  } catch (error) {
    console.log("ERROR", error);
    return error?.response?.data;
  }
};
